import NewProjectBillingForm from 'react-scale/corp/views/scalers/NewProjectBillingForm';
import { ProjectVisibilityType, ProjectWorkUnit } from '@scale/shared/types/projectParameterGroup';
import { TaskType } from '@scale/shared-types';
const BillingFormWrapper: React.FC<{
  onChange?: CallableFunction;
  currentState: any;
  targetCustomerId: string;
}> = ({ onChange, currentState, targetCustomerId }) => {
  const setter = (key: string, value: any) => {
    onChange && onChange({ ...currentState, [key]: value });
  };

  return (
    <NewProjectBillingForm
      projectBillingType={currentState?.projectBillingType || ProjectVisibilityType.Customer}
      setProjectBillingType={value => setter('projectBillingType', value)}
      setInternalForCustomer={value => setter('internalForCustomer', value)}
      internalForCustomer={currentState?.internalForCustomer}
      setOpsWorkflowPod={value => setter('opsWorkflowPod', value)}
      opsWorkflowPod={currentState?.opsWorkflowPod}
      projectWorkUnit={currentState?.projectWorkUnit || ProjectWorkUnit.Task}
      setProjectWorkUnit={value => setter('projectWorkUnit', value)}
      setBillingSla={value => setter('billingSla', value)}
      billingSla={currentState?.billingSla}
      taskType={currentState?.taskType || TaskType.TextCollection}
      createZeroSLA={currentState?.createZeroSLA || false}
      setCreateZeroSLA={value => setter('createZeroSLA', value)}
      customer={{ label: '', value: targetCustomerId }}
      setProjectBillingFlags={value => setter('projectBillingFlags', value)}
      projectBillingFlags={currentState?.projectBillingFlags || []}
      setProjectLanguage={value =>
        setter('languageCode', value)
      } /** @deprecated field, use languageCodes instead */
      projectLanguage={currentState?.languageCode}
      setHourlyWorkTypes={value => setter('hourlyWorkTypes', value)}
      hourlyWorkTypes={currentState?.hourlyWorkTypes || []}
    />
  );
};

export default BillingFormWrapper;
